import utilizationBar from "./utilizationBar.component";

const utilizationBarModule = angular
  .module("app.components.utilizationBar", [])
  .component("utilizationBar", utilizationBar);

export default utilizationBarModule;



// WEBPACK FOOTER //
// ./src/components/utilizationBar/utilizationBar.module.js